import React, { useState } from "react";
import { FormattedMessage, FormattedHTMLMessage, useIntl } from "react-intl";

import { getPaypalCode } from "../../../common/parameters";

import Icon from "../../icon";

import { Card, IconWrapper } from "./styles";
import messages from "./messages";

const DonateBanner = () => {
    const { locale } = useIntl();
    const [isLoading, setLoading] = useState(false);
    return (
        <Card>
            <IconWrapper>
                <Icon i="donate" />
            </IconWrapper>
            <h4>
                <FormattedHTMLMessage {...messages.h4} />
            </h4>
            <p>
                <FormattedHTMLMessage {...messages.p} />
            </p>
            <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
                <input type="hidden" name="cmd" value="_s-xclick" />
                <input type="hidden" name="hosted_button_id" value={getPaypalCode(locale)} />
                <button
                    type="submit"
                    name="submit"
                    className="button"
                    title="PayPal - The safer, easier way to pay online!"
                    onClick={() => {
                        setLoading(true);
                    }}
                    style={{
                        cursor: isLoading ? "progress" : "pointer",
                    }}
                >
                    <FormattedMessage {...messages.donate} />
                </button>
            </form>
        </Card>
    );
};

export default DonateBanner;
